import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { ButtonGroup } from "react-bootstrap";

// Const
import { organizationType } from "const/nuclias/organization";

// Hook
import useStickyHeader from "hooks/useStickyHeader";
import useTable from "hooks/useTable";

// Component
import Button from "components/Button";
import InlineTitle from "components/InlineTitle";
import SamlRolesTable from "./SamlRolesTable";
import SamlRolesPagination from "./SamlRolesPagination";
import AddOrEditSamlRoleModal from "../modals/AddOrEditSamlRoleModal";
import DeleteModal from "../modals/DeleteModal";

// Controller
import controller from "../controller";

// Const
import { tableColumn } from "../const";

const defaultModalStatus = {
  addAndEdit: {
    status: false,
    disabled: false,
  },
  delete: {
    status: false,
    disabled: true,
  },
  edit: {
    status: false,
    disabled: false,
  },
};

const SamlRoles = (props) => {
  const {
    selectedOrg,
    originSamlRoleList,
    successCallback
  } = props;

  const { tableRef, stickyStyle } = useStickyHeader();

  // Slice
  const { user: { user } } = useSelector((store) => store);
  const pageContext = useSelector(state => state.pageContext);

  // State
  const [modalStatus, setModalStatus] = useState({ ...defaultModalStatus });
  const [currentSamlRoleList, setCurrentSamlRoleList] = useState(originSamlRoleList);
  const [selectedSamlRole, setSelectedSamlRole] = useState(null);
  const [deletedSamlRoleId, setDeletedSamlRoleId] = useState(null);

  // Hook
  const {
    selectedPage, selectedPageLimit,
    tableData, getTableHeader,
    resetPage, changePage, changePageLimit, getCurrentPageData
  } = useTable(originSamlRoleList, tableColumn.samlRole[selectedOrg.orgType]);

  // Method
  const changeModalStatus = useCallback((type, value) => {
    setModalStatus({ ...modalStatus, [type]: { status: value } });
  }, [modalStatus]);

  // Side effect
  useEffect(() => {
    setCurrentSamlRoleList(getCurrentPageData());
  }, [selectedPage, selectedPageLimit, tableData]);

  return (
    <div className="mb-5">
      <InlineTitle label="SAML ROLES" isNonUnderline />
      <div className="d-flex justify-content-between mt-3 mb-2">
        <ButtonGroup>
          <Button
            label="ec211f7c20"
            className="btn-grey"
            onClick={() => {
              setSelectedSamlRole(null);
              changeModalStatus('addAndEdit', true);
            }}
          />
          <Button
            label="f2a6c498fb"
            className="btn-grey"
            disabled={!controller.getDeleteButtonState(currentSamlRoleList)}
            onClick={() => {
              setDeletedSamlRoleId(null);
              changeModalStatus('delete', true);
            }}
          />
        </ButtonGroup>
      </div>

      <SamlRolesTable
        tableRef={tableRef}
        stickyStyle={stickyStyle}
        tableHeader={getTableHeader}
        selectedPage={selectedPage}
        selectedPageLimit={selectedPageLimit}
        currentSamlRoleList={currentSamlRoleList}
        changeModalStatus={changeModalStatus}
        checkedAllState={() => controller.getCheckAllState(currentSamlRoleList)}
        toggleCheckedAll={() => setCurrentSamlRoleList(controller.toggleCheckedAll(currentSamlRoleList))}
        toggleChecked={index => setCurrentSamlRoleList(controller.toggleChecked(currentSamlRoleList, index))}
        selectSamlRoleCallback={samlRole => setSelectedSamlRole(samlRole)}
        handleDelete={id => setDeletedSamlRoleId(id)}
      />

      <SamlRolesPagination
        originSamlRoleList={originSamlRoleList}
        selectedPage={selectedPage}
        setSelectedPage={changePage}
        setSelectedPageLimit={changePageLimit}
      />

      {/* Add and edit modal */}
      <AddOrEditSamlRoleModal
        modalStatus={modalStatus}
        changeModalStatus={changeModalStatus}
        user={user}
        orgTreeMap={pageContext.orgTreeMap}
        selectedOrg={selectedOrg}
        selectedSamlRole={selectedSamlRole}
        successCallback={successCallback}
      />

      {/* Delete modal */}
      <DeleteModal
        modalStatus={modalStatus}
        selectedOrg={selectedOrg}
        sourceList={currentSamlRoleList}
        selectedId={deletedSamlRoleId}
        title="ba0f758ee8"
        description="cb7da70b58"
        changeModalStatus={() => changeModalStatus('delete', false)}
        execute={(orgId, idList) => controller.deleteSamlRole(orgId, idList)}
        successCallback={successCallback}
      />
    </div>
  );
};

export default SamlRoles;
